module.exports = __webpack_public_path__ + "static/media/image3.638ee69b.png";